/**
 * Small shared form primitives used across Semantic Schema pages
 * (Entity Settings tab, standalone Post FAQs page, etc.)
 */

import type { ReactNode } from 'react';

export function Section({
  title,
  icon,
  action,
  children,
}: {
  title: string;
  icon?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="bg-[var(--bg-secondary)] rounded-xl p-5 border border-[var(--bg-tertiary)]">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2 text-sm font-semibold">
          {icon}
          {title}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}

export function Field({
  label,
  className = '',
  children,
}: {
  label: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div className={className}>
      <label className="block text-xs text-white/60 mb-1">{label}</label>
      {children}
    </div>
  );
}
